<template>
  <div class="basic-group-info mt-4">
    <b-form-group>
      <div v-if="trainers.length">
        <b-col>
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="filteredResults"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-btn
                  :disabled="!filteredResults"
                  @click="filteredResults = ''"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          v-cloak
          responsive
          :fields="searchResultsFields"
          :items="trainers"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filteredResults"
          @filtered="onFiltered"
        >
          <template slot="cell(first_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTrainer', params: { id: row.item.uuid } }"
            >
              {{ row.item.first_name }} {{ row.item.middle_name }}
              {{ row.item.last_name }}
            </b-link>
            <br />
            <p class="small-date">country: {{ row.item.country }}</p>
            <p class="small-date">district: {{ row.item.region }}</p>
          </template>
          <template slot="cell(sex)" slot-scope="row">{{
            row.item.sex === "male" ? "M" : "F"
          }}</template>
          <template slot="cell(id)" slot-scope="row">
            <b-link class="add" @click.stop="setTrainer(row.item)">ADD</b-link>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="trainers.length || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TeamTrainer",
  props: {
    parent: String,
  },
  data() {
    return {
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "ADD" },
      ],
      currentPage: 1,
      perPage: 3,
      filteredResults: null,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINERS: "trainers/GET_TRAINERS",
      ADD_TRAINER: "teams/ADD_TRAINER",
      GET_TEAM_TRAINERS: "teams/GET_TEAM_TRAINERS",
    }),
    stopClick() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async setTrainer(item) {
      const trainersIds = [...this.$store.state.teams.team.trainers];
      if (trainersIds.includes(item.uuid)) {
        return;
      }

      const trainersNames = [...this.$store.state.teams.team.trainer_names];
      trainersIds.push(item.uuid);
      trainersNames.push(
        `${item.first_name} ${item.middle_name} ${item.last_name}`
      );
      this.$store.commit("teams/trainers", trainersIds);
      this.$store.commit("teams/trainer_names", trainersNames);

      if (!this.add) {
        await this.ADD_TRAINER({ id: item.uuid });
        await this.GET_TEAM_TRAINERS();
      }
    },
  },
  computed: {
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    trainers: {
      get() {
        return this.$store.state.trainers.trainers;
      },
    },
    team_trainer: {
      get() {
        return this.$store.state.teams.team.team_trainer;
      },
    },
    trainer_name: {
      get() {
        return this.$store.state.teams.team.trainer_name;
      },
    },
  },
  mounted() {
    this.GET_TRAINERS();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
